module.exports = __webpack_public_path__ + "img/Josh.072fea8a.png";